export { Scrimr, default } from './Scrimr'